import type { TaxInfoGatheringViewModel } from '@/features/jobs/details/tax-type/info-gathering/TaxInfoGatheringViewModel'
import { observer } from 'mobx-react-lite'
import {
  EmptyChecklistDocumentCardListItem,
  MissingChecklistDocumentsSection,
} from '@/features/jobs/details/tax-type/info-gathering/components/ChecklistItemsSections'
import { DocumentRequestedSupportingItemViewModel } from '@/features/jobs/details/tax-type/info-gathering/documents/DocumentRequestedSupportingItemViewModel'

interface MissingChecklistDocumentsSectionContainerProps {
  vm: TaxInfoGatheringViewModel
}

/**
 * Container for the missing documents section of the checklist.
 */
export const MissingChecklistDocumentsSectionContainer = observer(
  function MissingChecklistDocumentsSectionContainer({
    vm,
  }: MissingChecklistDocumentsSectionContainerProps) {
    if (vm.fetchChecklist.pending || vm.completion.type !== 'Incomplete') {
      // Since we won't be rendering the missing docs section
      // when there are no missing docs, we also won't render a
      // skeleton to avoid layout shifts for the desired end state.
      // That is, the user should eventually provide us all the missing docs.
      return null
    }

    const missingDocumentItems = vm.completion.incomplete.filter(
      (item): item is DocumentRequestedSupportingItemViewModel =>
        item instanceof DocumentRequestedSupportingItemViewModel,
    )

    if (!missingDocumentItems.length) {
      return null
    }

    return (
      <MissingChecklistDocumentsSection testId="missing-checklist-documents-section">
        {missingDocumentItems.map((itemVm) => (
          <EmptyChecklistDocumentCardListItem
            key={itemVm.item.id}
            title={itemVm.item.name}
            description={itemVm.item.shortDescription}
            variant="standout"
            onAction={itemVm.showDialog}
          />
        ))}
      </MissingChecklistDocumentsSection>
    )
  },
)
